module.exports = __webpack_public_path__ + "img/img_main_txt02.b0b01f1d.svg";